/**
 * BRINUTI — LAPOK-ELLENŐRZŐ, KÖZÖS ALAP (2026-10-26, TESZT-téma)
 *
 * Miért: sokan rosszul rendelik a lapokat (belívet), mert csak az 5. (utolsó)
 * lépés mondja meg, melyiket kapják, az előnézet pedig csak a borítót mutatja.
 * Ez a három fájl (alap, termékoldal, kosár) a lapokat mindenhol ugyanúgy,
 * KIEMELTEN mutatja — új kötelező lépés nélkül. A vevők felé a szó: „lapok”.
 *
 * Ez a fájl: a hat lapfajta adatai, a kétoldalas kép előállítása a téma
 * VALÓDI oldalfotóiból (assets/beliv-<fajta>-NN.jpg, ugyanazok, mint a „Lapozz
 * bele” szakaszban; a halvány vonalakat kontrasztosítjuk, hogy kicsiben is
 * látszódjanak), a nagyító (lightbox) és néhány segédfüggvény. Ha a képek nem
 * töltődnek be, a régi rajzolt (SVG) minta marad. Csak a window.BrinutiBeliv
 * objektumot hozza létre, és (kapcsolóval) a <html> elemre rak egy osztályt.
 */
(function () {
  'use strict';
  if (window.BrinutiBeliv) return;

  /* ---------- KAPCSOLÓ: ki van kapcsolva, amíg nem kérik ----------
     Az ÉLŐ témán (role: main) ez az egész ellenőrző csak akkor él, ha a
     vevő a ?belivteszt=1 címmel érkezett (a böngésző megjegyzi; a
     ?belivteszt=0 kikapcsolja). Tesztmásolaton / előnézetben (role:
     unpublished) mindig él. MINDENKINEK: ha igaz, mindenki látja – ezt kell
     átírni az élesítéskor. */
  var MINDENKINEK = true;
  var aktiv = MINDENKINEK;
  if (!aktiv) {
    try {
      var kapcsolo = new URLSearchParams(location.search).get('belivteszt');
      if (kapcsolo === '1') localStorage.setItem('bv-teszt', '1');
      if (kapcsolo === '0') localStorage.removeItem('bv-teszt');
      aktiv = localStorage.getItem('bv-teszt') === '1';
    } catch (e) {}
  }
  if (!aktiv) {
    var tema = window.Shopify && window.Shopify.theme;
    aktiv = !!(tema && tema.role && tema.role !== 'main');
  }
  if (!aktiv) return;
  document.documentElement.classList.add('bv-aktiv');

  /* Sorrend számít: az „Időpontbeosztó” is tartalmazza a „pont” szót.
     kep: [fájlnév-rész, bal oldal száma, jobb oldal száma] a téma oldalfotóiból. */
  var LISTA = [
    { k: 'onismereti', nev: 'Önismereti', le: 'Napi kérdések', minta: /önismereti/i, kep: ['onismereti', 12, 13] },
    { k: 'hatarido', nev: 'Határidőnapló', le: '2 oldalon 7 nap', minta: /határidő/i, kep: ['hataridonaplo', 56, 57] },
    { k: 'idopont', nev: 'Időpontbeosztó', le: 'Órás, 2 oldalon 7 nap', minta: /időpont/i, kep: ['idopontbeoszto', 56, 57] },
    { k: 'pontracsos', nev: 'Pontrácsos', le: 'Rajzhoz is', minta: /pontrácsos|pontozott/i, kep: ['pontracsos', 2, 3] },
    { k: 'vonalas', nev: 'Vonalas', le: 'Klasszikus', minta: /vonalas/i, kep: ['vonalas', 2, 3] },
    { k: 'sima', nev: 'Sima', le: 'Üres lapok', minta: /^\s*(üres|sima)\b/i, kep: ['sima', 2, 3] }
  ];

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function jelez(nev) {
    try { if (window.clarity) window.clarity('event', nev); } catch (e) {}
  }

  /** Szövegből lapfajta (pl. a Teeinblue opció szövege vagy a kosár „BRINUTI - önismereti” része). */
  function felismer(szoveg) {
    var t = String(szoveg || '').replace(/^\s*BRINUTI\s*[-–—]\s*/i, '');
    for (var i = 0; i < LISTA.length; i++) if (LISTA[i].minta.test(t)) return LISTA[i];
    return null;
  }

  function kulcsbol(k) {
    for (var i = 0; i < LISTA.length; i++) if (LISTA[i].k === k) return LISTA[i];
    return null;
  }

  /* ---------- Tartalék: rajzolt (SVG) kétoldalas minta ---------- */
  var TINTA = '#3b3b3b';
  var VONAL = '#c9c1ad';
  var PONT = '#8d8672';

  function oldal(k, x0, bal) {
    var s = '';
    var i, j, y;
    if (k === 'pontracsos') {
      for (i = 0; i < 9; i++) for (j = 0; j < 7; j++) {
        s += '<circle cx="' + (x0 + 14 + j * 11.7) + '" cy="' + (22 + i * 13.5) + '" r="1" fill="' + PONT + '"/>';
      }
    } else if (k === 'vonalas') {
      for (i = 0; i < 9; i++) { y = 24 + i * 13.5; s += '<line x1="' + (x0 + 8) + '" x2="' + (x0 + 90) + '" y1="' + y + '" y2="' + y + '" stroke="' + VONAL + '"/>'; }
    } else if (k === 'onismereti') {
      s += '<rect x="' + (x0 + 18) + '" y="' + (bal ? 30 : 20) + '" width="62" height="3.5" rx="1" fill="' + TINTA + '"/>';
      for (i = 0; i < 3; i++) {
        y = (bal ? 50 : 36) + i * 28;
        s += '<rect x="' + (x0 + 10) + '" y="' + y + '" width="' + (62 + (i % 2) * 14) + '" height="3" rx="1" fill="' + PONT + '"/>' +
          '<line x1="' + (x0 + 10) + '" x2="' + (x0 + 88) + '" y1="' + (y + 11) + '" y2="' + (y + 11) + '" stroke="' + VONAL + '"/>' +
          '<line x1="' + (x0 + 10) + '" x2="' + (x0 + 88) + '" y1="' + (y + 20) + '" y2="' + (y + 20) + '" stroke="' + VONAL + '"/>';
      }
    } else if (k === 'hatarido' || k === 'idopont') {
      var sor = k === 'idopont' ? 10 : 4;
      var tav = k === 'idopont' ? 12 : 30;
      for (i = 0; i < sor; i++) {
        y = 24 + i * tav;
        s += '<line x1="' + (x0 + 6) + '" x2="' + (x0 + 92) + '" y1="' + y + '" y2="' + y + '" stroke="' + VONAL + '"/>' +
          '<rect x="' + (x0 + 8) + '" y="' + (y - 7) + '" width="12" height="3" rx="1" fill="' + TINTA + '"/>';
      }
    }
    return s;
  }

  function konyvSvg(k) {
    return '<svg class="bv-konyv" viewBox="0 0 220 150" role="img" aria-hidden="true" focusable="false">' +
      '<rect x="6" y="5" width="208" height="140" rx="3" fill="#e9e3d2"/>' +
      '<rect x="10" y="8" width="98" height="134" rx="2" fill="#fff" stroke="#d3ccb8"/>' +
      '<rect x="112" y="8" width="98" height="134" rx="2" fill="#fff" stroke="#d3ccb8"/>' +
      oldal(k, 10, true) + oldal(k, 112, false) +
      '<rect x="102" y="8" width="16" height="134" fill="#000" opacity=".07"/>' +
      '</svg>';
  }

  /* ---------- Kétoldalas kép a téma valódi oldalfotóiból ---------- */
  var FORRAS = window.BrinutiLapokKep || {};   // {u: előtag, q: utótag} – a stylesheets.liquid adja
  var CACHE = {};    // "fajta|pw" -> Promise<dataURL|null>
  var UTOLSO = {};   // fajta -> {pw, src}: az utoljára elkészült kép (azonnali újrarajzoláshoz)
  var LUT = {};
  var HI = 250, GAMMA = 1.5;

  /* A halvány vonalak kisebb méretben még halványabbak, ezért a kontraszt
     erősebb, minél kisebb a kép (800 px-es oldalnál 212, 220 px-esnél ~230). */
  function lut(pw) {
    var lo = Math.round(212 + Math.max(0, 0.8 - pw / 1000) * 30);
    if (LUT[lo]) return LUT[lo];
    var t = new Uint8Array(256);
    for (var v = 0; v < 256; v++) {
      var x = Math.max(0, Math.min(1, (v - lo) / (HI - lo)));
      t[v] = Math.round(Math.pow(x, GAMMA) * 255);
    }
    LUT[lo] = t;
    return t;
  }

  /** A kép célmérete (eszközpixel) -> egy oldal szélessége; ~1,25× túlmintával, 40-es lépcsőkkel. */
  function pwSzel(szelPx) {
    var pw = Math.round(szelPx * 1.25 / 2.08 / 40) * 40;
    return Math.max(200, Math.min(1000, pw));
  }
  function elemPw(el) {
    var w = el.getBoundingClientRect().width || 300;
    return pwSzel(w * (window.devicePixelRatio || 1));
  }

  function oldalUrl(nev, n) {
    return (FORRAS.u || '') + 'beliv-' + nev + '-' + (n < 10 ? '0' + n : n) + '.jpg' + (FORRAS.q || '');
  }

  function betoltKep(url) {
    return new Promise(function (ok, nem) {
      var i = new Image();
      i.crossOrigin = 'anonymous';
      i.onload = function () { ok(i); };
      i.onerror = nem;
      i.src = url;
    });
  }

  /** Lépcsőzetes (felezéses) kicsinyítés: tiszta vonalak, nincs moiré. */
  function kicsinyit(img, w, h) {
    var forras = img, cw = img.naturalWidth, ch = img.naturalHeight, c, g;
    while (cw / 2 >= w) {
      cw = Math.round(cw / 2); ch = Math.round(ch / 2);
      c = document.createElement('canvas'); c.width = cw; c.height = ch;
      g = c.getContext('2d'); g.imageSmoothingQuality = 'high'; g.drawImage(forras, 0, 0, cw, ch);
      forras = c;
    }
    c = document.createElement('canvas'); c.width = w; c.height = h;
    g = c.getContext('2d'); g.imageSmoothingQuality = 'high'; g.drawImage(forras, 0, 0, w, h);
    return c;
  }

  function lapRajz(ctx, img, x, y, w, h, pw) {
    var c = kicsinyit(img, w, h);
    var g = c.getContext('2d');
    var d = g.getImageData(0, 0, w, h);
    var p = d.data, L = lut(pw);
    for (var i = 0; i < p.length; i += 4) {
      var t = L[Math.round(0.299 * p[i] + 0.587 * p[i + 1] + 0.114 * p[i + 2])] / 255;
      p[i] = 58 + 197 * t; p[i + 1] = 52 + 201 * t; p[i + 2] = 42 + 207 * t;
    }
    g.putImageData(d, 0, 0);
    ctx.drawImage(c, x, y);
  }

  function osszeRak(b, pw) {
    var a = b.kep;
    return Promise.all([betoltKep(oldalUrl(a[0], a[1])), betoltKep(oldalUrl(a[0], a[2]))]).then(function (im) {
      var ph = Math.round(pw * im[0].naturalHeight / im[0].naturalWidth);
      var pad = Math.round(pw * 0.04);
      var c = document.createElement('canvas');
      c.width = 2 * pw + 2 * pad; c.height = ph + 2 * pad;
      var x = c.getContext('2d');
      x.fillStyle = '#f3efe5';
      x.fillRect(0, 0, c.width, c.height);
      x.save();
      x.shadowColor = 'rgba(70,58,40,.45)'; x.shadowBlur = pad * 0.6; x.shadowOffsetY = pad * 0.25;
      x.fillStyle = '#fffdf9';
      x.fillRect(pad, pad, 2 * pw, ph);
      x.restore();
      lapRajz(x, im[0], pad, pad, pw, ph, pw);
      lapRajz(x, im[1], pad + pw, pad, pw, ph, pw);
      var sz = pw * 0.07;
      var gr = x.createLinearGradient(pad + pw - sz, 0, pad + pw + sz, 0);
      gr.addColorStop(0, 'rgba(60,52,38,0)'); gr.addColorStop(0.5, 'rgba(60,52,38,.38)'); gr.addColorStop(1, 'rgba(60,52,38,0)');
      x.fillStyle = gr;
      x.fillRect(pad + pw - sz, pad, 2 * sz, ph);
      x.strokeStyle = '#cdc6b6'; x.lineWidth = 1;
      x.strokeRect(pad + 0.5, pad + 0.5, 2 * pw - 1, ph - 1);
      return c.toDataURL('image/jpeg', 0.88);
    });
  }

  /** Promise<dataURL|null>; pw = egy oldal szélessége pixelben (200–1000). */
  function kep(k, pw) {
    var kulcs = k + '|' + pw;
    var b = kulcsbol(k);
    if (!b || !FORRAS.u) return Promise.resolve(null);
    if (CACHE[kulcs] === undefined) {
      CACHE[kulcs] = osszeRak(b, pw).then(function (src) {
        UTOLSO[k] = { pw: pw, src: src };
        return src;
      }, function () { return null; });
    }
    return CACHE[kulcs];
  }

  var NAGYITO = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false"><circle cx="10.5" cy="10.5" r="6.5" fill="none" stroke="currentColor" stroke-width="2"/><path d="M15.5 15.5 21 21M10.5 7.5v6M7.5 10.5h6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';

  /** A kép helyőrzője (az utoljára kész kép, különben üres, csillogó keret – a rajzolt minta csak hiba esetén) + nagyító gomb. */
  function kepHtml(k) {
    var u = UTOLSO[k];
    return '<div class="bv-kep" data-bv-kep="' + k + '">' +
      (u ? '<img class="bv-kep__img" alt="" data-pw="' + u.pw + '" src="' + u.src + '">' : '<div class="bv-kep__ures"></div>') +
      '<button type="button" class="bv-nagyit" data-bv-nagyit="' + k + '" aria-label="Nagyítás">' + NAGYITO + '</button></div>';
  }

  /** A képek cseréje az elem tényleges méretéhez készített, éles képre (ha nem sikerül, a rajzolt minta kerül oda). */
  function kepBetolt(gyoker) {
    var elemek = (gyoker || document).querySelectorAll('[data-bv-kep]');
    Array.prototype.forEach.call(elemek, function (el) {
      var k = el.getAttribute('data-bv-kep');
      var pw = elemPw(el);
      var im = el.querySelector('.bv-kep__img');
      if (im && im.getAttribute('data-pw') === String(pw)) return;
      if (el.getAttribute('data-bv-folyamat') === pw + '') return;
      el.setAttribute('data-bv-folyamat', pw + '');
      kep(k, pw).then(function (src) {
        if (!document.contains(el)) return;
        var cel = el.querySelector('.bv-kep__img');
        var hely = el.querySelector('.bv-kep__ures, .bv-konyv');
        if (!src) {
          if (hely && hely.classList.contains('bv-kep__ures')) hely.outerHTML = konyvSvg(k);
          return;
        }
        if (!cel) {
          cel = document.createElement('img');
          cel.className = 'bv-kep__img'; cel.alt = '';
          if (hely) hely.replaceWith(cel); else el.insertBefore(cel, el.firstChild);
        }
        cel.setAttribute('data-pw', pw + '');
        cel.src = src;
      });
    });
  }

  /* ---------- Nagyító (lightbox) ---------- */
  var lb = null;
  function lbKep(k, im, nagy) {
    var dpr = window.devicePixelRatio || 1;
    var szel = (nagy ? window.innerWidth * 2.3 : Math.min(window.innerWidth * 0.96, 1000)) * dpr;
    kep(k, pwSzel(szel)).then(function (src) {
      if (src && lb && document.contains(im) && lb.classList.contains('bv-lb--nagy') === nagy) im.src = src;
    });
  }
  function nagyit(k) {
    var b = kulcsbol(k);
    if (!b) return;
    zarLb();
    lb = document.createElement('div');
    lb.className = 'bv-lb';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.innerHTML = '<button type="button" class="bv-lb__zar" aria-label="Bezárás">×</button>' +
      '<div class="bv-lb__gorg"><img class="bv-lb__kep" alt="' + esc(b.nev + ' lapok') + '"></div>' +
      '<p class="bv-lb__cim"><b>' + esc(b.nev) + '</b> · ' + esc(b.le) + ' <span>Koppints a képre a nagyításhoz</span></p>';
    document.body.appendChild(lb);
    var im = lb.querySelector('.bv-lb__kep');
    if (UTOLSO[k]) im.src = UTOLSO[k].src;
    lbKep(k, im, false);
    lb.addEventListener('click', function (e) {
      if (e.target === im) {
        lb.classList.toggle('bv-lb--nagy');
        lbKep(k, im, lb.classList.contains('bv-lb--nagy'));
      } else zarLb();
    });
    jelez('lapok_nagyitas');
  }
  function zarLb() {
    if (lb) { lb.remove(); lb = null; }
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') zarLb(); });
  document.addEventListener('click', function (e) {
    var n = e.target && e.target.closest ? e.target.closest('[data-bv-nagyit]') : null;
    if (!n) return;
    e.preventDefault();
    e.stopPropagation();
    nagyit(n.getAttribute('data-bv-nagyit'));
  }, true);

  window.BrinutiBeliv = {
    LISTA: LISTA,
    esc: esc,
    jelez: jelez,
    felismer: felismer,
    kulcsbol: kulcsbol,
    konyvSvg: konyvSvg,
    kepHtml: kepHtml,
    kepBetolt: kepBetolt
  };
})();